import api from "./axios";

// Helper function to extract error message from API response
export const getOperatorErrorMessage = (error) => {
  if (error && error.response && error.response.data) {
    if (error.response.data.message) {
      return error.response.data.message;
    }
    if (
      error.response.data.errors &&
      Array.isArray(error.response.data.errors)
    ) {
      return error.response.data.errors[0];
    }
    if (
      error.response.data.errors &&
      typeof error.response.data.errors === "object"
    ) {
      const firstError = Object.values(error.response.data.errors)[0];
      if (Array.isArray(firstError)) {
        return firstError[0];
      }
      return String(firstError);
    }
  }
  return error?.message || "An unexpected error occurred";
};

// Operators API service
export const operatorsApi = {
  // Get all operators
  getAll: async (isActive = true) => {
    try {
      const response = await api.get(`/operators?isActive=${isActive}`);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Get operator by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/operators/${id}`);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Create new operator
  create: async (operatorData) => {
    try {
      const response = await api.post("/operators", operatorData);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Update operator details
  update: async (id, operatorData) => {
    try {
      const response = await api.put(`/operators/${id}`, operatorData);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Delete operator
  delete: async (id) => {
    try {
      const response = await api.delete(`/operators/${id}`);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Update operator clients
  updateClients: async (id, clientIds) => {
    try {
      const response = await api.put(`/operators/${id}/clients`, { clientIds });
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Get operators by client
  getByClient: async (clientId) => {
    try {
      const response = await api.get(`/operators/by-client/${clientId}`);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Update payout amount
  updatePayout: async (id, payoutAmount) => {
    try {
      const response = await api.put(`/operators/${id}/payout`, {
        payoutAmount,
      });
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },

  // Generate QR code for 2FA
  generateQRCode: async (id) => {
    try {
      const response = await api.post(`/operators/${id}/generate-qr`);
      return response.data;
    } catch (error) {
      return { error: getOperatorErrorMessage(error) };
    }
  },
};

export default operatorsApi;
